import * as faceapi from "face-api.js";

/*
 * Tiny Face Detector: this model is used to detect faces on webcam. Documentation can be found here:
 * https://github.com/justadudewhohacks/face-api.js/#getting-started-face-detection-options
 */

export async function checkFace(
  media: HTMLVideoElement | HTMLImageElement,
  threshold: number,
): Promise<faceapi.FaceDetection[]> {
  const tinyFaceDetectorOptions = new faceapi.TinyFaceDetectorOptions({
    inputSize: 320,
    scoreThreshold: threshold,
  });
  const result: faceapi.FaceDetection[] = await faceapi.detectAllFaces(media, tinyFaceDetectorOptions);
  return result;
}
